import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { OperationsAccessService } from '../services/operations-access.service';

export const operationsPermissionGuard: CanActivateFn = (route) => {
  const accessService = inject(OperationsAccessService);
  const permissions = (route.data['permissions'] ?? []) as readonly string[];

  return accessService
    .getCurrentUser()
    .pipe(map((user) => (accessService.canAccessModule(user, permissions) ? true : accessService.redirectToFirstAccessibleRoute(user))));
};
